module.exports = __webpack_public_path__ + "media/images/icon_arrow_triangle3-f1a646c763d33bd573149f355b6a832e.png";